import React from "react";
import { Typography } from "@mui/material";
import { styled } from "@mui/system";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import {
  formatSignedNumber,
  formatPositionPl,
  formatPositionSharesValue,
} from "../utils/portfolioExport";

export const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#5A5A5A",
    color: "#fff",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const Line = ({ label, value }) => (
  <Typography color="inherit" sx={{ fontSize: "12px" }}>
    {label}: {value}
  </Typography>
);

export function MarketTooltip({ dataSource, fetched, children }) {
  return (
    <HtmlTooltip
      title={
        <>
          <Line label="Market" value={dataSource} />
          <Line label="Updated" value={fetched} />
        </>
      }
    >
      {children}
    </HtmlTooltip>
  );
}

function formatSizeTooltip(value, isLong) {
  if (value == null || value === "" || Number.isNaN(Number(value))) return "";
  const abs = Math.abs(Number(value)).toFixed(2);
  return isLong ? `${abs}%` : `(${abs}%)`;
}

function buildTradeMetric(withoutTradesValue, todayValue, formatter) {
  const hasWithout =
    withoutTradesValue != null &&
    withoutTradesValue !== "" &&
    !Number.isNaN(Number(withoutTradesValue));
  const hasToday =
    todayValue != null &&
    todayValue !== "" &&
    !Number.isNaN(Number(todayValue));

  return {
    yest: formatter(withoutTradesValue) || "0",
    today: formatter(todayValue) || "0",
    changed:
      hasWithout &&
      hasToday &&
      Number(withoutTradesValue) !== Number(todayValue),
  };
}

export function getTradesTooltipValues(row, isLong) {
  const p = isLong ? "long" : "short";
  return {
    size: buildTradeMetric(
      row?.[`${p}_sizeWithoutTrades`],
      row?.[`${p}_size`],
      (v) => formatSizeTooltip(v, isLong)
    ),
    shares: buildTradeMetric(
      row?.[`${p}_deltaadjustedsharecountWithoutTrades`],
      row?.[`${p}_deltaadjustedsharecount`],
      (v) => formatPositionSharesValue(v, isLong)
    ),
    pl: buildTradeMetric(
      row?.[`${p}_pLWithoutTrades`],
      row?.[`${p}_pL`],
      formatPositionPl
    ),
    cost: buildTradeMetric(
      row?.[`${p}_costWithoutTrades`],
      row?.[`${p}_cost`],
      formatSignedNumber
    ),
  };
}

export function TradesTooltip({ enabled, title, yest, today, children }) {
  if (!enabled) return children;
  return (
    <HtmlTooltip
      placement="bottom"
      title={
        <>
          <Typography color="inherit" sx={{ fontSize: "12px" }}>
            <b>{title}</b>
          </Typography>
          <Line label="Yest" value={yest} />
          <Line label="Today" value={today} />
        </>
      }
    >
      {children}
    </HtmlTooltip>
  );
}
